module.exports = __webpack_public_path__ + "img/ruso.9714638e.svg";